import i18next from 'i18next';
import trim from 'lodash/trim';

const validEmailRegExp = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);

const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined);

const required = (value: any) => (trim(value) ? undefined : i18next.t('fieldRequired'));

const minNumberValue = (min) => (value) =>
  value >= min || value === undefined
    ? undefined
    : i18next.t('invalidNumber', {
        min,
      });

const requiredWithMessage = (message) => (value) => value ? undefined : message;

const phone = (value) => {
  let tempValue = value.replace(/\s+/g, '');
  tempValue = tempValue.replace('+', '');
  tempValue = tempValue.replace('7', '');
  tempValue = tempValue.replace('(', '');
  tempValue = tempValue.replace(')', '');
  tempValue = tempValue.replace(/-/g, '');
  tempValue = tempValue.replace(/_/g, '');

  const isValid = tempValue.length < 10 ? i18next.t('phoneNumberInvalid') : undefined;

  return isValid;
};

const email = (value) => {
  if (!value) return undefined;

  return validEmailRegExp.test(value) ? undefined : i18next.t('invalidEmail');
};

export { composeValidators, required, requiredWithMessage, phone, email, minNumberValue };
